const DOMAINS_WITHOUT_EXPENSE = [
  'ea.amtrav.com',
  'certify.amtrav.com',
  'certifydemo.amtrav.com',
  'sutisoft.amtrav.com',
];

const USER_TYPE = {
  traveler: 'T',
  admin: 'A',
};

const ACCOUNT_LEVEL = { premium: 4 };

export default (viewSettings, accountLevel) => {
  const { pathname, search } = document.location;
  const { host } = window.location;
  const { navReports: navReportsLevel } = viewSettings;
  const reportsPermissionAdminOnly = USER_TYPE.admin === navReportsLevel;
  const reportsPermissionAdminOrTraveler = [USER_TYPE.admin, USER_TYPE.traveler].includes(navReportsLevel);
  const dataType = 'SiteNav';
  return [
    {
      type: dataType,
      title: 'Home',
      url: '/',
      metadata: {
        keywords: 'home, homepage',
        isActive: false,
        isVisible: true,
      },
    },
    {
      type: dataType,
      title: 'Flights & Rail',
      url: '/flights/',
      metadata: {
        sectionTitle: 'Go',
        keywords: 'flights, rail, search, go',
        isActive: pathname.includes('/flights'),
        isVisible: viewSettings.navFlights,
      },
    },
    {
      type: dataType,
      title: 'Hotels',
      url: '/hotels/',
      metadata: {
        sectionTitle: 'Go',
        keywords: 'hotels, search, go',
        isActive: pathname.includes('/hotels'),
        isVisible: viewSettings.navHotels,
      },
    },
    {
      type: dataType,
      title: 'Cars',
      url: '/cars/',
      metadata: {
        sectionTitle: 'Go',
        keywords: 'cars, search, go',
        isActive: pathname.includes('/cars'),
        isVisible: viewSettings.navCars,
      },
    },
    {
      type: dataType,
      title: 'Trips',
      url: '/trips/',
      metadata: {
        sectionTitle: 'See',
        keywords: 'trips, bookings',
        isActive: pathname.includes('/trips') && search.indexOf('approve:!') === -1,
        isVisible: viewSettings.navMyTrips,
      },
    },
    {
      type: dataType,
      title: 'Invites',
      url: '/invites/',
      metadata: {
        sectionTitle: 'See',
        keywords: 'invites, meeting',
        isActive: pathname.includes('/invites'),
        isVisible: viewSettings.navMeetingInvites,
      },
    },
    {
      type: dataType,
      title: 'Expense Reports',
      url: '/expenses/',
      metadata: {
        sectionTitle: 'See',
        keywords: 'expenses, receipt',
        isActive: pathname.includes('/expenses'),
        isVisible: viewSettings.navExpenseReports && DOMAINS_WITHOUT_EXPENSE.indexOf(host) === -1,
      },
    },
    {
      type: dataType,
      title: 'Unused Tickets',
      url: '/reports/?jsr=(historyReportId:7)',
      metadata: {
        sectionTitle: 'See',
        keywords: 'unused, tickets',
        isActive: search.indexOf('historyReportId:7') !== -1,
        isVisible:
          (viewSettings.navTravelerDashboard && viewSettings.navReports === USER_TYPE.traveler) ||
          viewSettings.navReports === USER_TYPE.admin,
      },
    },
    {
      type: dataType,
      title: 'Travel Reports',
      url: '/reports/',
      metadata: {
        sectionTitle: 'See',
        keywords: 'travel, reports, dashboard',
        isActive: pathname.includes('/reports') && search.indexOf('historyReportId:7') === -1,
        isVisible:
          (viewSettings.navTravelerDashboard && viewSettings.navReports === USER_TYPE.traveler) ||
          viewSettings.navReports === USER_TYPE.admin,
      },
    },
    {
      type: dataType,
      title: 'Tracking & Safety',
      url: '/safety/?jsr=(dt:1,historyReportId:61)',
      metadata: {
        sectionTitle: 'See',
        keywords: 'tracking, safety, reports, dashboard',
        isActive: pathname.includes('/safety'),
        isVisible: viewSettings.navReports === USER_TYPE.admin,
      },
    },
    {
      type: dataType,
      title: 'Meetings',
      url: '/gather/',
      metadata: {
        sectionTitle: 'Gather',
        keywords: 'meetings, gather, travel',
        isActive: pathname.includes('/gather'),
        isVisible: viewSettings.navMeetingManage,
      },
    },
    {
      type: dataType,
      title: 'Guest Travel',
      url: '/gather/',
      metadata: {
        sectionTitle: 'Gather',
        keywords: 'guest, meetings, gather, travel',
        isActive: false,
        isVisible: viewSettings.navMeetingManage,
      },
    },
    {
      type: dataType,
      title: 'People',
      url: '/users/',
      metadata: {
        sectionTitle: 'Manage',
        keywords: 'people, team, users',
        isActive: pathname.includes('/users'),
        isVisible: viewSettings.navUsers,
      },
    },
    {
      type: dataType,
      title: 'Approvals',
      url: '/trips/?jsr=(approve:!t)',
      metadata: {
        sectionTitle: 'Manage',
        keywords: 'approvals, trips',
        isActive: pathname.includes('/trips') && search.indexOf('approve:!') !== -1,
        isVisible: viewSettings.navApproveTrips,
      },
    },
    {
      type: dataType,
      title: 'Company Settings',
      url: '/account/',
      metadata: {
        sectionTitle: 'Manage',
        keywords: 'company, settings',
        isActive: pathname.includes('/account'),
        isVisible: viewSettings.navCompanySettings,
      },
    },
    {
      type: dataType,
      title: 'Travel Policy',
      url: '/policies/',
      metadata: {
        sectionTitle: 'Manage',
        keywords: 'travel, policy',
        isActive: pathname.includes('/policies'),
        isVisible: viewSettings.navTravelPolicy,
      },
    },
    {
      type: dataType,
      title: 'My Profile',
      url: '/profile/',
      metadata: {
        keywords: 'my, profile',
        isActive: false,
        isVisible: viewSettings.navMyProfile,
      },
    },
    {
      type: dataType,
      title: 'COVID Resource Center',
      url: '/resource-center',
      metadata: {
        keywords: 'covid, resource center',
        isActive: false,
        isVisible: true,
        newWindow: true,
      },
    },
    // travel report links
    {
      type: dataType,
      title: 'Dashboard',
      url: '/reports/?jsr=(historyReportId:11)',
      metadata: {
        category: 'Travel Reports / Overview',
        keywords: 'travel report, overview, dashboard',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Trip Success',
      url: '/reports/?jsr=(historyReportId:12)',
      metadata: {
        category: 'Travel Reports / Overview',
        keywords: 'travel report, overview, trip success',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'CO2 Report',
      url: '/reports/?jsr=(historyReportId:13)',
      metadata: {
        category: 'Travel Reports / Overview',
        keywords: 'travel report, overview, co2 report',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Total Trip',
      url: '/reports/?jsr=(historyReportId:24)',
      metadata: {
        category: 'Travel Reports / Spend',
        keywords: 'travel reports, spend, total trip',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Other',
      url: '/reports/?jsr=(historyReportId:25)',
      metadata: {
        category: 'Travel Reports / Spend',
        keywords: 'travel reports, spend, other',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Fees',
      url: '/reports/?jsr=(historyReportId:26)',
      metadata: {
        category: 'Travel Reports / Spend',
        keywords: 'travel reports, spend, fees',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Monthly',
      url: '/reports/?jsr=(historyReportId:27)',
      metadata: {
        category: 'Travel Reports / Spend',
        keywords: 'travel reports, spend, monthly',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Credit Card Reconciliation',
      url: '/reports/?jsr=(historyReportId:28)',
      metadata: {
        category: 'Travel Reports / Spend',
        keywords: 'travel reports, spend, credit card reconciliation',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Booked Vs Actual',
      url: '/reports/?jsr=(historyReportId:29)',
      metadata: {
        category: 'Travel Reports / Spend',
        keywords: 'travel reports, spend, booked vs actual',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Air Spend',
      url: '/reports/?jsr=(historyReportId:31)',
      metadata: {
        category: 'Travel Reports / Air',
        keywords: 'travel reports, air, air spend',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Air Ticket',
      url: '/reports/?jsr=(historyReportId:32)',
      metadata: {
        category: 'Travel Reports / Air',
        keywords: 'travel reports, air, air ticket',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Airline',
      url: '/reports/?jsr=(historyReportId:33)',
      metadata: {
        category: 'Travel Reports / Air',
        keywords: 'travel reports, air, airline',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Air City Pair',
      url: '/reports/?jsr=(historyReportId:34)',
      metadata: {
        category: 'Travel Reports / Air',
        keywords: 'travel reports, air, air city pair',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Car Spend',
      url: '/reports/?jsr=(historyReportId:41)',
      metadata: {
        category: 'Travel Reports / Car',
        keywords: 'travel reports, car, car spend',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Car Vendor',
      url: '/reports/?jsr=(historyReportId:42)',
      metadata: {
        category: 'Travel Reports / Car',
        keywords: 'travel reports, car, car vendor',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Hotel Spend',
      url: '/reports/?jsr=(historyReportId:51)',
      metadata: {
        category: 'Travel Reports / Hotel',
        keywords: 'travel reports, hotel, hotel spend',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Hotel Chain',
      url: '/reports/?jsr=(historyReportId:52)',
      metadata: {
        category: 'Travel Reports / Hotel',
        keywords: 'travel reports, hotel, hotel chain',
        isVisible: reportsPermissionAdminOrTraveler,
      },
    },
    {
      type: dataType,
      title: 'Traveler Activity',
      url: '/reports/?jsr=(historyReportId:64)',
      metadata: {
        category: 'Travel Reports / Travelers',
        keywords: 'travel reports, travelers, traveler activity',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Registered Traveler',
      url: '/reports/?jsr=(historyReportId:65)',
      metadata: {
        category: 'Travel Reports / Travelers',
        keywords: 'travel reports, travelers, registered traveler',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Policy Compliance Summary',
      url: '/reports/?jsr=(historyReportId:81)',
      metadata: {
        category: 'Travel Reports / Compliance',
        keywords: 'travel reports, compliance, policy compliance summary',
        isVisible: reportsPermissionAdminOnly,
      },
    },
    {
      type: dataType,
      title: 'Out of Policy Log',
      url: '/reports/?jsr=(historyReportId:82)',
      metadata: {
        category: 'Travel Reports / Compliance',
        keywords: 'travel reports, compliance, out of policy log',
        isVisible: accountLevel === ACCOUNT_LEVEL.premium,
      },
    },
  ];
};
